import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, prevResetKey: props.resetKey };
  }

  static getDerivedStateFromError(error) {
    // Chunk load failure after a new deploy — reload to get fresh chunks
    if (
      error?.name === "ChunkLoadError" ||
      error?.message?.includes("Loading chunk") ||
      error?.message?.includes("Failed to fetch dynamically imported module")
    ) {
      window.location.reload();
      return { hasError: false, error: null };
    }
    return { hasError: true, error };
  }

  // Reset error state when the route changes
  static getDerivedStateFromProps(props, state) {
    if (props.resetKey !== state.prevResetKey) {
      return { hasError: false, error: null, prevResetKey: props.resetKey };
    }
    return null;
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught:", error, info);
    // For non-chunk errors, redirect to home instead of showing white screen
    if (
      error?.name !== "ChunkLoadError" &&
      !error?.message?.includes("Loading chunk") &&
      !error?.message?.includes("Failed to fetch dynamically imported module")
    ) {
      window.location.href = "/";
    }
  }

  render() {
    if (this.state.hasError) {
      return null;
    }
    return this.props.children;
  }
}
